<template>
    <div class="container-fluid">
        <div>
            <div class="card">
                <div id="topo" class="card-header">
                    <div class="row">
                        <div class="col col-xs-2">
                            <h4 class="panel-title">
                                <span class="title">Consulta de Notas Fiscais.</span>
                                <br />
                                <span class="navigation">Relatório > Consulta Notas Fiscais</span>
                            </h4>
                        </div>
                    </div>
                </div>

                <div class="card-body">
                    <error-list :erros="erros" />

                    <div class="row">
                        <div class="col-md-2 mb-2">
                            <label>Tipo Emissão:</label>
                            <span class="p-fluid">
                                <Dropdown id="tipoEmissao" v-model="filtroEmissao" :options="filtrosEmissao"
                                    optionLabel="name"  />
                            </span>
                        </div>
                        <div class="col-md-12 col-lg-4 mb-2" v-if="this.filtroEmissao.key === 'T'">
                            <label>Prestador:</label>
                            <span class="p-fluid">
                                <AutoComplete id="prestador" v-model="selectedPrestador" :dropdown="true"
                                    :suggestions="filteredPrestadores" @complete="searchPrestadores($event)"
                                    @keyup.enter="pesquisar" field="detail"
                                    placeholder="CPF/CNPJ/Nome/Inscrição Prestador" />
                            </span>
                        </div>

                        <div class="col-md-12 col-lg-4 mb-2" v-if="this.filtroEmissao.key === 'P'">
                            <label>Tomador:</label>
                            <span class="p-fluid">
                                <AutoComplete id="tomador" v-model="selectedTomador" :dropdown="true"
                                    :suggestions="filteredTomadores" @complete="searchTomadores($event)"
                                    @keyup.enter="pesquisar" field="detail" placeholder="CPF/CNPJ/Nome/Inscrição Tomador" />
                            </span>
                        </div>
                        <div class="col-md-3 mb-3">
                            <label>Período:</label>
                            <span class="p-fluid">
                                
                                    <CustomCalendar id="dataIni" name="dataFim" v-model="dataFatoGeradorIni" :showIcon="true"
                                        dateFormat="dd/mm/yy" placeholder="Período Inicial" @keyup.enter="pesquisar"
                                        v-maska="'##/##/####'"/>

                                    <CustomCalendar id="dataFim" name="dataFim" v-model="dataFatoGeradorFim" :showIcon="true"
                                        dateFormat="dd/mm/yy" placeholder="Período Final" @keyup.enter="pesquisar"
                                        v-maska="'##/##/####'" />

                                
                            </span>
                        </div>
                        <div class="col-md-3 mb-3">
                            <label>Intervalo de Notas:</label>
                            <span class="p-fluid">
                                <div class="p-inputgroup">
                                    <inputText type="text" id="filtroNumeroini" v-model="filtroNumeroIni"
                                        placeholder="Número Inicial" autocomplete="off" @keyup.enter="pesquisar"
                                        class="input-numeros"/>

                                    <inputText type="text" id="filtroNumerofim" v-model="filtroNumeroFim"
                                        placeholder="Número Final" autocomplete="off" @keyup.enter="pesquisar" />
                                </div>
                            </span>
                        </div>
                        <div class="col-md-2 mb-2">
                            <label>Situação:</label>
                            <span class="p-fluid">
                                <Dropdown id="situacao" v-model="filtroSituacao" :options="filtroSituacoes"
                                    optionLabel="name" placeholder="Selecione uma Situação" />
                            </span>
                        </div>
                        <div class="col-md-4 mb-2">
                            <label>Origem:</label>
                            <span class="p-fluid">
                                <Dropdown id="origem" v-model="filtroOrigem" :options="filtroOrigens" optionLabel="name"
                                    placeholder="Selecione uma Origem" />
                            </span>
                        </div>
                        <div class="col-md-3 mb-3">
                            <label>Período Rps:</label>
                            <span class="p-fluid">
                                
                                    <CustomCalendar id="dataEmissaoRpsIni" name="dataEmissaoRpsIni" v-model="dataEmissaoRpsIni"
                                        :showIcon="true" dateFormat="dd/mm/yy" placeholder="Período Rps Inicial"
                                        @keyup.enter="pesquisar" v-maska="'##/##/####'" />

                                    <CustomCalendar id="dataEmissaoRpsFim" name="dataEmissaoRpsFim" v-model="dataEmissaoRpsFim"
                                        :showIcon="true" dateFormat="dd/mm/yy" placeholder="Período Rps Final"
                                        @keyup.enter="pesquisar" v-maska="'##/##/####'" />

                                
                            </span>
                        </div>
                        <div class="col-md-3 mb-3">
                            <label>Intervalo Rps:</label>
                            <span class="p-fluid">
                                <div class="p-inputgroup">
                                    <InputText type="text" id="filtroRpsNumeroIni" v-model="filtroRpsNumeroIni" placeholder="Número RPS Inicial" autocomplete="off" @keyup.enter="pesquisar" class="input-numeros" />

                                    <InputText type="text" id="filtroRpsNumeroFim" v-model="filtroRpsNumeroFim" placeholder="Número RPS Final" autocomplete="off" @keyup.enter="pesquisar" />
                                </div>
                            </span>
                        </div>

                        <div class="col-md-12 col-lg-4 mb-2">
                            <label>Serviço:</label>
                            <span class="p-fluid">
                                <AutoComplete id="servico" v-model="selectedServico" :dropdown="true"
                                    :suggestions="filteredServicos" @complete="searchServico($event)" field="detail"
                                    placeholder="Código/Nome do Serviço">
                                    <template #item="slotProps">
                                        <div class="p-fluid" style="max-width: 50vw">
                                            {{ slotProps.item.detail }}
                                        </div>
                                    </template>
                                </AutoComplete>
                            </span>
                        </div>
                        <div class="col-md-5 col-lg-4 mb-2">
                            <label>Regime:</label>
                            <span class="p-fluid">
                                <Dropdown id="regime" v-model="selectedRegime" :options="regimes" optionLabel="nomeRegime"
                                    placeholder="Selecione um Regime" />
                            </span>
                        </div>
                        <div class="col-md-2 mb-2">
                            <label>Município Incidência:</label>
                            <span class="p-fluid">
                                <Dropdown id="incidencia" v-model="filtroIncidencia" :options="filtroIncidencias"
                                    optionLabel="name" placeholder="Selecione uma Incidência" />
                            </span>
                        </div>
                        <div class="col-md-2 mb-2">
                            <label>ISS Retido?</label>
                            <span class="p-fluid">
                                <Dropdown id="retido" v-model="filtroRetido" :options="filtrosRetido" optionLabel="name"
                                    placeholder="Selecione se é Retenção" />
                            </span>
                        </div>
                        <div class="col-md-2 mb-2">
                            <label>Simples Nacional?</label>
                            <span class="p-fluid">
                                <Dropdown id="optanteSS" v-model="filtroOptanteSs" :options="filtroSimNao"
                                    optionLabel="name" placeholder="Selecione se é Optante Simples" />
                            </span>
                        </div>

                        <div class="col-md-2 mb-2">
                            <label>Situação Débito:</label>
                            <span class="p-fluid">
                                <Dropdown id="situacaoDebito" v-model="filtroSituacaoDebito"
                                    :options="filtroSituacoesDebito" optionLabel="name"
                                    placeholder="Selecione uma Situação de Débito" />
                            </span>
                        </div>

                    </div>
                    <hr />
                    <div class="mb-2">

                        <Button class="btn btn-primary mr-2" type="button" icon="pi pi-print" label="Imprimir" title="Imprimir"
                            :disabled="loading" @click="imprimirConsulta()" ></Button>

                            <Button class="btn btn-primary" type="button" icon="pi pi-file-excel" label="XLS" title="XLS"
                            :disabled="loading" @click="imprimirExcel()"></Button>


                    </div>


                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { maska } from 'maska'
import LoginService from "../services/acesso/login.service";
import PessoaService from "../services/tributario/contribuinte.cadastro.service";
import ServicoService from "../services/tributario/servicos.service";
import RegimeService from "../services/tributario/regime.service";
import ReportService from "../services/report.service";
import CustomCalendar from "../components/global/CustomCalendar.vue";

export default {
    directives: { maska },
    name: "RelatorioDeclaracao",

    components: {
        CustomCalendar
    },
    data() {
        return {
            erros: [],
            loading: null,
            filtroNumeroIni: null,
            filtroNumeroFim: null,
            filtroRpsNumeroIni: null,
            filtroRpsNumeroFim: null,
            dataFatoGeradorIni: null,
            dataFatoGeradorFim: null,
            dataEmissaoRpsIni: null,
            dataEmissaoRpsFim: null,
            selectedPrestador: null,
            selectedTomador: null,
            filteredPrestadores: null,
            filteredTomadores: null,
            filtroEmissao:"",
            filtrosEmissao: [
                { name: "Notas Prestadas", key: "P" },
                { name: "Notas Tomadas", key: "T" }
            ],
            filtroSituacao: "",
            filtroSituacoes: [
                { name: "Todos", key: "T" },
                { name: "Ativa", key: "A" },
                { name: "Cancelada", key: "C" },
                { name: "Substituida", key: "S" }
            ],
            filtroIncidencia: "",
            filtroIncidencias: [
                { name: "Todos", key: "T" },
                { name: "Município", key: "M" },
                { name: "Fora do Município", key: "F" }
            ],
            filtroRetido: "",
            filtrosRetido: [
                { name: "Todos", key: "T" },
                { name: "Sim", key: "R" },
                { name: "Não", key: "N" }
            ],
            filtroOptanteSs: "",
            filtroSimNao: [
                { name: "Todos", key: "T" },
                { name: "Sim", key: "S" },
                { name: "Não", key: "N" }
            ],
            filtroOrigem: "",
            filtroOrigens: [
                { name: "Todos", key: "T" },
                { name: "Nota Avulsa", key: "Nfse Avulsa" },
                { name: "Nfse", key: "Nfse" }
            ],
            filtroSituacaoDebito: "",
            filtroSituacoesDebito: [
                { name: "Todos", key: "T" },
                { name: "Quitado", key: "Quitado" },
                { name: "Em Aberto", key: "Em Aberto" }
            ],
            selectedServico: null,
            filteredServicos: null,
            selectedRegime: null,
            regimes: []
        };
    },
    mounted() {
        // document.getElementById("compIni").focus();
    },
    created() {
        this.currentUser = LoginService.currentUserValue;
        if (this.currentUser.usuario && this.currentUser.usuario.idCliente === '19533831040781681800D2584C905F8A') {//simoes filho
            this.filtroOrigens.push({ name: "Nfse Tomador", key: "Nfse Tomador" });
        } else {
            this.filtroOrigens.push({ name: "Daps", key: "Daps" });
        }
        this.filtroEmissao = this.filtrosEmissao[0];
        setTimeout(async () => {
            this.regimes = await RegimeService.findAllRegimes(
                this.currentUser.usuario.idCliente
            );
        }, 250);
        this.dataFatoGeradorIni = new Date();
        this.dataFatoGeradorIni.setDate(this.dataFatoGeradorIni.getDate()-30);
        this.dataFatoGeradorFim = new Date();

    },
    methods: {
        searchServico(event) {
            this.processando(true);
            setTimeout(async () => {
                this.filteredServicos = await ServicoService.findAllByClienteFiltro(
                    event.query,
                    this.currentUser.usuario.idCliente
                );
                this.processando(false);
            }, 250);

        },
        searchPrestadores(event) {
            setTimeout(async () => {
                let idContr = (this.filtroEmissao.key === 'T' ? this.currentUser.contribuinte.idContribuinte : '');
                this.filteredPrestadores = await PessoaService.comboByContribuinteFiltro(
                    this.currentUser.usuario.idCliente,
                    idContr,
                    event.query
                );
            }, 550);
        },
        searchTomadores(event) {
            setTimeout(async () => {
                let idContr = (this.filtroEmissao.key === 'P' ? this.currentUser.contribuinte.idContribuinte : '');
                this.filteredTomadores = await PessoaService.comboByContribuinteFiltro(
                    this.currentUser.usuario.idCliente,
                    idContr,
                    event.query
                );
            }, 550);
        },
        imprimirConsulta() {
            this.imprimirConsultaTipo('pdf');
        },
        imprimirExcel() {
            this.imprimirConsultaTipo('xls');
        },
        imprimirConsultaTipo(tipo) {
            this.processando(true);
            var msg = null;
            if (!this.dataFatoGeradorIni) {
                msg = "É necessário informar o período inicial";
            } else if (!this.dataFatoGeradorIni) {
                msg = "É necessário informar o período final!";
            } 
            if (!msg) {
                let docPrestador = this.filtroEmissao.key === 'P' ? this.currentUser.contribuinte.documento : (this.selectedPrestador ? this.selectedPrestador.documento : null);
                let docTomador = this.filtroEmissao.key === 'T' ? this.currentUser.contribuinte.documento : (this.selectedTomador ? this.selectedTomador.documento : null);
                ReportService.imprimir((tipo == 'pdf' ? "ConsultaNotas" : "ConsultaNotasXls"), [
                    {
                        param: "id_cliente",
                        string: this.currentUser.usuario.idCliente,
                    },
                    {
                        param: "doc_prestador",
                        string: docPrestador,
                        label: "Prestador"
                    },
                    {
                        param: "doc_tomador",
                        string: docTomador,
                        label: "Tomador"
                    },
                    {
                        param: "codigo_servico",
                        string: (this.selectedServico ? this.selectedServico.codigoServico : null),
                        label: "Serviço"
                    },
                    {
                        param: "data_fato_gerador_ini",
                        date: this.dataFatoGeradorIni,
                        label: "Período Inicial"
                    },
                    {
                        param: "data_fato_gerador_fim",
                        date: this.dataFatoGeradorFim,
                        label: "Período Final"
                    },
                    {
                        param: "situacao",
                        string: (this.filtroSituacao ? this.filtroSituacao.key : null),
                        label: "Situação",
                        labelValor: (this.filtroSituacao ? this.filtroSituacao.name : null)
                    },
                    {
                        param: "rps_data_emissao_ini",
                        date: this.dataEmissaoRpsIni,
                        label: "Período Rps Inicial"
                    },
                    {
                        param: "rps_data_emissao_fim",
                        date: this.dataEmissaoRpsFim,
                        label: "Período Rps Final"
                    },
                    {
                        param: "numero_ini",
                        bigInteger: this.filtroNumeroIni,
                        label: "Número Inicial"
                    },
                    {
                        param: "numero_fim",
                        bigInteger: this.filtroNumeroFim,
                        label: "Número Final"
                    },
                    {
                        param: "rps_numero_ini",
                        string: this.filtroRpsNumeroIni,
                        label: "Número Rps Inicial"
                    },
                    {
                        param: "rps_numero_fim",
                        string: this.filtroRpsNumeroFim,
                        label: "Número Rps Final"
                    },
                    {
                        param: "id_regime",
                        integer: (this.selectedRegime ? this.selectedRegime.id : null),
                        label: "Regime",
                        labelValor: (this.selectedRegime ? this.selectedRegime.nomeRegime : null)
                    },
                    {
                        param: "tipo_recolhimento",
                        string: (this.filtroRetido && this.filtroRetido.key != 'T' ? this.filtroRetido.key : null),
                        label: "Retido",
                        labelValor: (this.filtroRetido ? this.filtroRetido.name : null)
                    },
                    {
                        param: "optante",
                        string: (this.filtroOptanteSs && this.filtroOptanteSs.key != 'T' ? this.filtroOptanteSs.key : null),
                        label: "Simples Nacional",
                        labelValor: (this.filtroOptanteSs ? this.filtroOptanteSs.name : null)
                    },
                    {
                        param: "local_incidencia",
                        string: (this.filtroIncidencia && this.filtroIncidencia.key != 'T' ? this.filtroIncidencia.key : null),
                        label: "Local Incidência",
                        labelValor: (this.filtroIncidencia ? this.filtroIncidencia.name : null)
                    },
                    {
                        param: "origem",
                        string: (this.filtroOrigem && this.filtroOrigem.key != 'T' ? this.filtroOrigem.key : null),
                        label: "Origem",
                        labelValor: (this.filtroOrigem ? this.filtroOrigem.name : null)
                    },
                    {
                        param: "situacao_debito",
                        string: (this.filtroSituacaoDebito && this.filtroSituacaoDebito.key != 'T' ? this.filtroSituacaoDebito.key : null),
                        label: "Situação Débito",
                        labelValor: (this.filtroSituacaoDebito ? this.filtroSituacaoDebito.name : null)
                    }
                ], tipo)
                    .then(
                        () => { },
                        error => {
                            this.$root.$emit("alert:warn", "Erro ao Imprimir!");
                            console.log(error);
                        }
                    )
                    .then(() => {
                        this.processando(false);
                    });
            } else {
                this.$root.$emit("alert:warn", msg);
            }
        },
        processando(show) {
            if (show) {
                this.loading = true;
                this.$root.$emit("loading:show");
            } else {
                this.loading = false;
                this.$root.$emit("loading:hide");
            }
        }
    },
    computed: {}
};
</script>
  
<style scoped>
input#filtroNumeroini {
    border-radius: 12px;
    margin-right: 20px;
}

input#filtroNumerofim {
    border-radius: 12px;
}

input#filtroRpsNumeroIni {
    border-radius: 12px;
    margin-right: 20px;
}

input#filtroRpsNumeroFim {
    border-radius: 12px;
}

</style>